export const CONTEST_LIST_REQUEST = "CONTEST_LIST_REQUEST";
export const CONTEST_LIST_SUCCESS = "CONTEST_LIST_SUCCESS";
export const CONTEST_LIST_FAIL = "CONTEST_LIST_FAIL";

export const CONTEST_DETAILS_REQUEST = "CONTEST_DETAILS_REQUEST";
export const CONTEST_DETAILS_SUCCESS = "CONTEST_DETAILS_SUCCESS";
export const CONTEST_DETAILS_FAIL = "CONTEST_DETAILS_FAIL";
